// Bucket keys are calendar days ('YYYY-MM-DD', sometimes followed by a midnight time). They are
// read as UTC midnight and formatted in UTC so the label never shifts with the browser zone.
export const formatBucketDate = (
  dateString: string,
  options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' }
): string => {
  const day = /^\d{4}-\d{2}-\d{2}/.exec(dateString)?.[0];
  if (!day) return dateString;
  return new Date(day).toLocaleDateString(undefined, { ...options, timeZone: 'UTC' });
};
